(function() {
  'use strict';

  const STORAGE_KEY = 'hfb_recently_viewed_products';
  const MAX_PRODUCTS = 10;

  function getRecentlyViewedProducts() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.error('Error reading recently viewed products:', error);
      return [];
    }
  }

  function saveRecentlyViewedProducts(products) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
    } catch (error) {
      console.error('Error saving recently viewed products:', error);
    }
  }

  function addRecentlyViewedProduct(productHandle) {
    if (!productHandle) return;

    productHandle = String(productHandle);
    let recentProducts = getRecentlyViewedProducts();
    recentProducts = recentProducts.filter(handle => handle !== productHandle);
    recentProducts.unshift(productHandle);

    if (recentProducts.length > MAX_PRODUCTS) {
      recentProducts = recentProducts.slice(0, MAX_PRODUCTS);
    }

    saveRecentlyViewedProducts(recentProducts);
  }

  function init() {
    const isProductPage = window.location.pathname.includes('/products/');
    
    if (!isProductPage) {
      return;
    }

    const pathParts = window.location.pathname.split('/');
    const productsIndex = pathParts.indexOf('products');
    
    if (productsIndex >= 0 && pathParts.length > productsIndex + 1) {
      let productHandle = pathParts[productsIndex + 1];
      productHandle = productHandle.replace(/\/$/, '');
      
      if (/^\d+$/.test(productHandle)) {
        console.log('Skipping product ID:', productHandle, '- IDs are not supported');
        return;
      }
      
      if (productHandle && productHandle.length > 0) {
        addRecentlyViewedProduct(productHandle);
        console.log('Recently viewed product added:', productHandle);
        
        if (typeof window.updateRecentlyViewedInCart === 'function') {
          window.updateRecentlyViewedInCart();
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.RecentlyViewedProducts = {
    getRecentlyViewedProducts: getRecentlyViewedProducts,
    addRecentlyViewedProduct: addRecentlyViewedProduct
  };
})();
